import Vue from 'vue'
import Router from 'vue-router'
import routes from './router'
import baseConfig from '@/config/base'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes,
  base: `/${baseConfig.route}/`
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '猿典科技'
  document.body.style.backgroundColor = to.meta.bodyColor || '#F7F7F7'
  next()
})

router.afterEach(() => {
  window.scrollTo(0, 0)
})

export default router
